import React, { useState, useEffect, useRef } from "react"
import { Map } from "./map";
import { getGeoLocation, Marker } from "./googleMap";

interface Props {
    latitude?: number;
    longitude?: number;
    onChange: (latitude: number, longitude: number) => void;
    hint?: string;
}

export const GeocoderMap = (props: Props) => {

    const [addressToGeocode, setAddressToGeocode] = useState(props.hint ?? "")
    const map = React.useRef<Map>(null);

    let markerRef = useRef<Marker | null>(null);

    const moveMarker = (marker: Marker): void => {
        props.onChange(marker.lat, marker.lng);
    }

    const positionMarker = () => {
        if (props.latitude && props.longitude) {
            if (markerRef.current == null) {
                markerRef.current = map.current!.Api.addMarker({
                    lat: props.latitude,
                    lng: props.longitude,
                    title: addressToGeocode,
                    draggable: true
                });
                map.current!.Api.ChangeMarkerPosition.register(moveMarker)
                map.current!.Api.setCenter(props.latitude, props.longitude);
            }
            else {
                markerRef.current.setPosition(props.latitude, props.longitude);
                markerRef.current.setTitle(addressToGeocode);
            }
        }
    }

    const onGeocodeAddress = async () => {
        const result = await getGeoLocation({ address: addressToGeocode || props.hint })
        props.onChange(result.lat, result.lng);
        map.current!.Api.setCenter(result.lat, result.lng);
        map.current!.Api.setZoom(15);
    }

    useEffect(() => {
        positionMarker();
    }, [props.latitude, props.longitude])

    return <>
        <div className="input-group">
            <input
                type="text"
                className="form-control"
                placeholder="Cerca nella mappa"
                value={addressToGeocode || props.hint || ""}
                onChange={x => setAddressToGeocode(x.target.value)}
            />
            <button type="button" onClick={onGeocodeAddress} className="btn btn-outline-secondary">
                <i className="fas fa-search-location fa-lg" aria-hidden="true" /> Cerca nella mappa
            </button>
        </div>
        <small className="form-text"><i className="fas fa-question-circle" /> "Cerca nella mappa" e aggiusta la posizione trascinando l'indicatore</small>
        <Map ref={map} style={{ marginTop: 10 }} />
    </>
}